import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerSearchInputComponent } from './borrower-search-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    BorrowerSearchInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    PhoneModule,
  ],
  exports: [
    BorrowerSearchInputComponent,
  ]
})
export class BorrowerSearchInputModule { }
